import { useEffect, useRef, useState } from "react";

import { Box, CircularProgress } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import { TLessonDocument } from "../../../../@types";

export type TLessonDocumentAudioProps = {
	file: TLessonDocument;
};

export function LessonDocumentAudio({ file }: TLessonDocumentAudioProps) {
	const [isLoading, setIsLoading] = useState(true);
	const [searchParams] = useSearchParams();
	const tab = searchParams.get("tab") ?? "";
	const isLearningMaterial = tab === "learning-material";
	const ref = useRef<HTMLVideoElement>(null);

	useEffect(() => {
		if (!isLearningMaterial) {
			if (ref.current && !ref.current.paused) {
				ref.current.pause();
			}
		}
	}, [isLearningMaterial]);

	const onLoad = () => {
		setIsLoading(false);
	};

	return (
		<div className="video-container">
			<audio
				className="video"
				onLoadedMetadata={onLoad}
				controls
				controlsList="nodownload"
				ref={ref}>
				<source src={file.url} type="audio/mp3" />
			</audio>
			{isLoading && (
				<Box
					sx={{
						position: "absolute",
						zIndex: 1,
						display: "inline-flex",
						margin: "auto",
					}}>
					<CircularProgress />
				</Box>
			)}
		</div>
	);
}
